import gql from "graphql-tag";

/**
 * @param {id} id
 */
export const DELETE_VENTILATOR = gql`
  mutation deleteVentilator($id: uuid!) {
    __typename
    delete_ventilator(where: { id: { _eq: $id } }) {
      returning {
        id
      }
    }
  }
`;
